import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrl: './toasts.component.scss',
  host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
})
export class ToastsComponent {

  public isBrowser: boolean;

  constructor(
    public toastService: ToastService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {

    this.isBrowser = isPlatformBrowser(this.platformId);

  }

}
